import React, { useState } from "react";

import {
  Heading,
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Text,
  useColorModeValue,
  //
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
} from "@chakra-ui/react";

import { CiRead } from "react-icons/ci";

import { useDispatch } from "react-redux";

import { updateIsViewed } from "../../../redux/actions/utilActions";

const MailViewed = () => {
  const dispatch = useDispatch();

  const [bg, setBg] = useState("trasparent");

  return (
    <Menu closeOnSelect={false}>
      <MenuButton as={Flex}>
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          px={"4px"}
          bg={bg}
          borderColor={"#FFF"}
          borderWidth={1}
          borderRadius={15}
        >
          <CiRead size={19} />
          {/* <Text fontSize={10} ml={"2px"}>
            20
          </Text> */}
        </Flex>
      </MenuButton>
      <MenuList minWidth="200px">
        <MenuOptionGroup
          type="radio"
          onChange={(e) => {
            setBg("#FE9203");
            dispatch(updateIsViewed(e));
          }}
        >
          <MenuItemOption key={1} value="1">
            Viewed
          </MenuItemOption>
          <MenuItemOption key={2} value="2">
            Not Viewed
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};

export default MailViewed;
